import React from 'react';
import FormInfoTip from '../ui/FormInfoTip';
import { rosterFormInfo } from '../../utils/rosterFormInfo';
import {
  MAIN_EVENTER_TIMING_PRESETS,
  MAX_MAIN_EVENTER_DAYS,
  MIN_MAIN_EVENTER_DAYS,
  clampMainEventerTimingDays,
  formatMainEventerDaysLabel,
} from '../../utils/mainEventerCooldown';

function MainEventerTimingFields({
  enabled = true,
  durationDays,
  cooldownDays,
  onDurationChange,
  onCooldownChange,
  idPrefix = 'main-eventer',
}) {
  if (!enabled) return null;

  const normalizedDurationDays = clampMainEventerTimingDays(durationDays);
  const normalizedCooldownDays = clampMainEventerTimingDays(cooldownDays);

  return (
    <div className="bg-dark rounded-3 p-3 mb-4">
      <div className="form-info-row--between mb-2">
        <span className="small fw-semibold text-light">Ciclo Main Eventer</span>
        <FormInfoTip title={rosterFormInfo.mainEventerTiming.title}>
          {rosterFormInfo.mainEventerTiming.body}
        </FormInfoTip>
      </div>

      <p className="text-muted-brand small mb-3">
        Default consigliato: 2 settimane attivo e 2 settimane di pausa. Puoi
        comunque personalizzare entrambe le durate.
      </p>

      <div className="d-flex flex-wrap gap-2 mb-3">
        {MAIN_EVENTER_TIMING_PRESETS.map((preset) => {
          const isActive =
            preset.durationDays === normalizedDurationDays &&
            preset.cooldownDays === normalizedCooldownDays;

          return (
            <button
              key={preset.id}
              type="button"
              className="btn btn-sm text-start"
              onClick={() => {
                onDurationChange?.(preset.durationDays);
                onCooldownChange?.(preset.cooldownDays);
              }}
              style={{
                background: isActive
                  ? 'rgba(52, 152, 219, 0.18)'
                  : 'rgba(255,255,255,0.05)',
                border: isActive
                  ? '1px solid rgba(52, 152, 219, 0.55)'
                  : '1px solid rgba(255,255,255,0.08)',
                color: isActive ? 'var(--brand-secondary)' : 'white',
              }}
            >
              <strong className="d-block small">{preset.label}</strong>
              <span className="d-block" style={{ fontSize: '0.72rem' }}>
                {formatMainEventerDaysLabel(preset.durationDays)} /{' '}
                {formatMainEventerDaysLabel(preset.cooldownDays)}
              </span>
            </button>
          );
        })}
      </div>

      <div className="row g-3">
        <div className="col-12 col-lg-6">
          <div className="form-info-row--between mb-2">
            <label
              className="form-label small text-brand-muted mb-0"
              htmlFor={`${idPrefix}-duration`}
            >
              Durata attiva
            </label>
            <span className="badge bg-brand-secondary text-dark rounded-pill">
              {formatMainEventerDaysLabel(normalizedDurationDays)}
            </span>
          </div>
          <div className="d-flex align-items-center gap-3">
            <i className="bi bi-lightning-charge-fill text-brand-secondary"></i>
            <input
              id={`${idPrefix}-duration`}
              type="range"
              className="form-range flex-grow-1"
              min={MIN_MAIN_EVENTER_DAYS}
              max={MAX_MAIN_EVENTER_DAYS}
              step={1}
              value={normalizedDurationDays}
              onChange={(event) =>
                onDurationChange?.(
                  clampMainEventerTimingDays(event.target.value, normalizedDurationDays)
                )
              }
            />
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <div className="form-info-row--between mb-2">
            <label
              className="form-label small text-brand-muted mb-0"
              htmlFor={`${idPrefix}-cooldown`}
            >
              Cooldown
            </label>
            <span className="badge bg-brand-secondary text-dark rounded-pill">
              {formatMainEventerDaysLabel(normalizedCooldownDays)}
            </span>
          </div>
          <div className="d-flex align-items-center gap-3">
            <i className="bi bi-hourglass-split text-brand-secondary"></i>
            <input
              id={`${idPrefix}-cooldown`}
              type="range"
              className="form-range flex-grow-1"
              min={MIN_MAIN_EVENTER_DAYS}
              max={MAX_MAIN_EVENTER_DAYS}
              step={1}
              value={normalizedCooldownDays}
              onChange={(event) =>
                onCooldownChange?.(
                  clampMainEventerTimingDays(event.target.value, normalizedCooldownDays)
                )
              }
            />
          </div>
        </div>
      </div>

      <div className="small text-muted-brand mt-3">
        Il Main Eventer restera attivo per{' '}
        <strong className="text-light">
          {formatMainEventerDaysLabel(normalizedDurationDays)}
        </strong>{' '}
        e, una volta terminato o rimosso, tornera disponibile dopo{' '}
        <strong className="text-light">
          {formatMainEventerDaysLabel(normalizedCooldownDays)}
        </strong>
        .
      </div>
    </div>
  );
}

export default MainEventerTimingFields;
